module.exports = "/images/avatar-s-6.jpg?0c96c10d8849f0377363d152f6726da2";